import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHILD_DEVELOPMENT_OVERVIEW';

export const {action: setViewMode} = createAction(`${domain}/SET_VIEW_MODE`, viewMode => ({viewMode}));

export const {action: setAsOf} = createAction(`${domain}/SET_AS_OF`, asOf => ({asOf}));
